class AriatSlider {
    constructor(container) {
        this.container = container;
        this.slider = container.querySelector('.js-slider');
        this.slides = container.querySelectorAll('.js-slider_tile');
        this.progressBar = container.querySelector('.progress-bar');
        this.prevBtn = container.querySelector('.prev-button');
        this.nextBtn = container.querySelector('.next-button');

        // Dragging state
        this.isDragging = false;
        this.startX = 0;
        this.scrollLeft = 0;
        this.isScrolling = false;

        this.init();
    }

    init() {
        this.addEventListeners();
        this.updateProgressBar();
        this.updateButtons();
    }

    addEventListeners() {
        // Mouse events for dragging
        this.slider.addEventListener('mousedown', this.startDragging.bind(this));
        this.slider.addEventListener('mousemove', this.drag.bind(this));
        this.slider.addEventListener('mouseup', this.stopDragging.bind(this));
        this.slider.addEventListener('mouseleave', this.stopDragging.bind(this));

        // Touch events for mobile
        this.slider.addEventListener('touchstart', this.startDragging.bind(this));
        this.slider.addEventListener('touchmove', this.drag.bind(this));
        this.slider.addEventListener('touchend', this.stopDragging.bind(this));

        // Scroll event for progress bar
        this.slider.addEventListener('scroll', () => {
            if (!this.isScrolling) {
                window.requestAnimationFrame(() => {
                    this.updateProgressBar();
                    this.updateButtons();
                    this.isScrolling = false;
                });
                this.isScrolling = true;
            }
        });

        // Navigation buttons
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.navigate('prev'));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.navigate('next'));

        // Progress bar click
        if (this.progressBar) {
            this.progressBar.addEventListener('click', this.handleProgressBarClick.bind(this));
        }

        // Window resize
        window.addEventListener('resize', () => {
            this.updateProgressBar();
            this.updateButtons();
        });
    }

    startDragging(e) {
        this.isDragging = true;
        this.slider.classList.add('dragging');
        
        // Get starting position
        this.startX = e.type === 'mousedown' ? e.pageX : e.touches[0].pageX;
        this.scrollLeft = this.slider.scrollLeft;
    }

    drag(e) {
        if (!this.isDragging) return;
        e.preventDefault();

        // Calculate distance moved
        const x = e.type === 'mousemove' ? e.pageX : e.touches[0].pageX;
        const distance = x - this.startX;
        
        // Scroll the slider
        this.slider.scrollLeft = this.scrollLeft - distance;
    }

    stopDragging() {
        this.isDragging = false;
        this.slider.classList.remove('dragging');
    }

    updateProgressBar() {
        if (!this.progressBar) return;

        const scrollWidth = this.slider.scrollWidth - this.slider.clientWidth;
        const scrolled = (this.slider.scrollLeft / scrollWidth) * 100;
        
        this.progressBar.style.setProperty('--progress', `${scrolled}%`);
    }

    updateButtons() {
        if (!this.prevBtn || !this.nextBtn) return;

        const isAtStart = this.slider.scrollLeft <= 0;
        const isAtEnd = this.slider.scrollLeft >= (this.slider.scrollWidth - this.slider.clientWidth - 1);

        this.prevBtn.classList.toggle('hidden', isAtStart);
        this.nextBtn.classList.toggle('hidden', isAtEnd);
    }

    navigate(direction) {
        const slideWidth = this.slides[0].offsetWidth + 20; // 20px is the gap
        const scrollAmount = direction === 'prev' ? -slideWidth : slideWidth;

        this.slider.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }

    handleProgressBarClick(e) {
        const rect = this.progressBar.getBoundingClientRect();
        const percentage = (e.clientX - rect.left) / rect.width;
        const scrollWidth = this.slider.scrollWidth - this.slider.clientWidth;
        
        this.slider.scrollTo({
            left: scrollWidth * percentage,
            behavior: 'smooth'
        });
    }
}

// Initialize all sliders when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.slider-container');
    sliders.forEach(slider => new AriatSlider(slider));
});


document.addEventListener('DOMContentLoaded', function() {
  // Initialize Slick slider
  $('.js-featured-collection-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    arrows: true,
    prevArrow: $('.featured-collection-button--prev'),
    nextArrow: $('.featured-collection-button--next'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          variableWidth: true
        }
      }
    ]
  });
  
  // Update progress bar
  const updateProgressBar = (slick) => {
    const totalSlides = slick.slideCount;
    const currentSlide = slick.currentSlide;
    const progress = ((currentSlide + 1) / totalSlides) * 100;
    $('.featured-collection-progress__bar').css('width', `${progress}%`);
  };
  
  // Initialize progress bar
  const slider = $('.js-featured-collection-carousel').slick('getSlick');
  updateProgressBar(slider);
  
  // Update featured image and progress bar on slide change
  $('.js-featured-collection-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    updateProgressBar(slick);
    const nextProduct = $(slick.$slides[nextSlide]);
    const newImageUrl = nextProduct.find('.featured-collection-item').data('product-image');
    const featuredImage = $('.js-featured-collection-image img');
    
    featuredImage.fadeOut(300, function() {
      $(this).attr('src', newImageUrl).fadeIn(300);
    });
  });
});
